import type { CreateProps } from "react-admin";
import { Create, SimpleForm, SelectInput, FormDataConsumer } from "react-admin";
import ChulaSabilFields from "./ChulaSabilFields";
import EstablishmentFields from "./EstablishmentFields";
import MuttavatteenYearlyFields from "./MuttavatteenYearlyFields";
import { SabilHouseholdMembersInput } from "../components/SabilHouseholdMembersInput";
import { SABIL_TYPE_OPTIONS, getType } from "@/constants";
import {
  isMuttavatteenSabilType,
  validateMuttavatteenHolderWhatsapp,
} from "../sabil-household-members";
import { transformSabilDataCreate } from "./transform-sabil-data-create";

const validateSabilDataCreate = (values: Record<string, unknown>) => {
  const whatsappError = validateMuttavatteenHolderWhatsapp(values);
  return whatsappError ? { whatsappNo: whatsappError } : {};
};

const SabilDataCreate = (props: CreateProps) => (
  <Create {...props} transform={transformSabilDataCreate}>
    <SimpleForm warnWhenUnsavedChanges validate={validateSabilDataCreate} sx={{ maxWidth: 900 }}>
      <SelectInput
        source="sabilType"
        label="Sabil Type"
        helperText="Select any one of Chula, Establisment, Muttavatteen, or Muttavatteen Yearly"
        choices={SABIL_TYPE_OPTIONS}
        fullWidth
        isRequired
      />
      <FormDataConsumer>
        {({ formData }) => {
          const type = getType(formData.sabilType as string);
          if (type === "CHULA") {
            return (
              <>
                <ChulaSabilFields />
                {isMuttavatteenSabilType(formData.sabilType as string) ? (
                  <SabilHouseholdMembersInput />
                ) : null}
              </>
            );
          }
          if (type === "ESTABLISHMENT") {
            return <EstablishmentFields />;
          }
          if (formData.sabilType === "MUTTAVATTEEN_YEARLY") {
            return (
              <>
                <MuttavatteenYearlyFields />
                <SabilHouseholdMembersInput />
              </>
            );
          }
          return null;
        }}
      </FormDataConsumer>
    </SimpleForm>
  </Create>
);

export default SabilDataCreate;
